<template>
    <v-container class="py-8 px-6 pl-12" fluid>
        <v-card outlined style="border: 0 solid white" class="mt-n10">
            <v-card-text class="mt-n3">
                <div class="cont-title" style="float: left;">결제 정보</div>
            </v-card-text>
        </v-card>

        <v-row class="mt-16">
            <v-col class="mb-0">
                <router-view></router-view>
            </v-col>
        </v-row>

        <v-row>
            <v-col>※ 더 자세한 정보는 <b>070-4512-0000</b> 으로 문의해 주세요.</v-col>
        </v-row>
    </v-container>
</template>
<script>

export default {
    name: 'pay',
    components: {},
    data: () => ({}),
    created() {
        this.$store.commit('layoutFlag', true)
        this.$store.commit('menuId', 'pay')
    },
    methods: {}
}
</script>

